// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__37EVN","inner":"Footer_inner__aXwLw","nextIcon":"Footer_nextIcon__1tmKe","innerLeft":"Footer_innerLeft__1Q7tb"};